module.exports = __webpack_public_path__ + "static/media/DinningArea-b-c.03091868.webp";